<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 16 16"
  >
    <!-- Arrow Path -->
    <path
      class="transition-transform group-hover:translate-y-[12%]"
      fill="currentColor"
      d="M7.432 10.968a.8.8 0 0 0 .264.168.752.752 0 0 0 .608 0 .8.8 0 0 0 .264-.168l3.2-3.2a.803.803 0 1 0-1.136-1.136L8.8 8.472V.8a.8.8 0 1 0-1.6 0v7.672l-1.832-1.84a.803.803 0 0 0-1.136 1.136Z"
    />
    <!-- Line with borders Path -->
    <path
      fill="currentColor"
      d="M15.2 9.6a.8.8 0 0 0-.8.8v3.2a.8.8 0 0 1-.8.8H2.4a.8.8 0 0 1-.8-.8v-3.2a.8.8 0 1 0-1.6 0v3.2A2.4 2.4 0 0 0 2.4 16h11.2a2.4 2.4 0 0 0 2.4-2.4v-3.2a.8.8 0 0 0-.8-.8Z"
    />
  </svg>
</template>
